module.exports = __webpack_public_path__ + "static/reputable-clients-4f2d9c006f883b66738a123f7de63ebe.svg";